import React from 'react';
import { ScrollProgressBar } from '../components/ScrollProgressBar';
import { StickyTopBar } from '../components/StickyTopBar';
import { HeroSection } from '../components/HeroSection';
import { PainAgitationSection } from '../components/PainAgitationSection';
import { CreatorSection } from '../components/CreatorSection';
import { ScienceSection } from '../components/ScienceSection';
import { TimelineSection } from '../components/TimelineSection';
import { PriceAnchoringSection } from '../components/PriceAnchoringSection';
import { FeaturedTestimonial } from '../components/FeaturedTestimonial';
import { TestimonialCarousel } from '../components/TestimonialCarousel';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { FooterSection } from '../components/FooterSection';
export function LuckyFlushPage() {
  return <div className="min-h-screen bg-navy font-sans text-cream selection:bg-gold/30 selection:text-cream" data-id="element-369">
      <ScrollProgressBar data-id="element-370" />
      <StickyTopBar data-id="element-371" />

      <main className="flex flex-col w-full" data-id="element-372">
        <HeroSection data-id="element-373" />
        <PainAgitationSection data-id="element-374" />
        <CreatorSection data-id="element-375" />
        <ScienceSection data-id="element-376" />
        <TimelineSection data-id="element-377" />
        <PriceAnchoringSection data-id="element-378" />
        <FeaturedTestimonial data-id="element-379" />
        <TestimonialCarousel data-id="element-380" />
        <GuaranteeSection data-id="element-381" />
        <FAQSection data-id="element-382" />
        <FinalCTASection data-id="element-383" />
      </main>

      <FooterSection data-id="element-384" />
    </div>;
}